import {Component, Input, OnInit} from '@angular/core';
import {Plate} from "./plate";

@Component({
  selector: 'app-plate',
  templateUrl: './plate.component.html',
  styleUrls: ['./plate.component.css']
})
export class PlateComponent implements OnInit {
  @Input() plate: Plate;
  @Input() width = 500;

  constructor() { }

  ngOnInit(): void {
  }

  get style(): any {
    return {
      width: `${this.width * this.plate.width}px`,
      height: `${this.width * this.plate.height }px`
    }
  }
}
